"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistentStateMiddleware = exports.PersistentState = void 0;
class PersistentState {
    static instance() {
        if (!PersistentState._instance) {
            PersistentState._instance = new PersistentState();
        }
        return PersistentState._instance;
    }
    save(key, data) {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        }
        catch (e) {
            console.error('Error saving to local storage ', key);
        }
    }
    load(key) {
        try {
            const rv = localStorage.getItem(key);
            if (rv) {
                return JSON.parse(rv);
            }
        }
        catch (e) {
            console.error('Error loading from local storage ', key);
        }
    }
    loadAll() {
        try {
            const rv = {};
            for (let i = 0; i < localStorage.length; i++) {
                const k = localStorage.key(i);
                if (k) {
                    rv[k] = localStorage.getItem(k);
                }
            }
            return rv;
        }
        catch (_a) {
            return {};
        }
    }
    dispatchAll(dispatch) {
        const all = this.loadAll();
        Object.keys(all).forEach(k => dispatch({ type: k, payload: all[k] }));
    }
}
exports.PersistentState = PersistentState;
exports.PersistentStateMiddleware = (store) => (next) => (action) => {
    var _a;
    try {
        if ((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.__save) {
            PersistentState.instance().save(action.type, action.payload);
        }
        return next(action);
    }
    catch (err) {
        // goble
    }
};
function Dispatch() {
    throw new Error("Function not implemented.");
}
//# sourceMappingURL=PersistentState.js.map